(function(){
  function init(){
    // Mega menu
    document.querySelectorAll('[data-dlf-mega-toggle]').forEach(function(btn){
      if(btn.dataset.dlfBound) return; btn.dataset.dlfBound='1';
      var wrap=btn.closest('.dlf-nav__wrap'); var mega=wrap&&wrap.querySelector('.dlf-mega'); if(!mega) return;
      var t;
      function open(){clearTimeout(t);mega.classList.add('is-open');btn.setAttribute('aria-expanded','true');}
      function close(){t=setTimeout(function(){mega.classList.remove('is-open');btn.setAttribute('aria-expanded','false');},120);}
      btn.addEventListener('click',function(e){e.preventDefault();mega.classList.contains('is-open')?(mega.classList.remove('is-open'),btn.setAttribute('aria-expanded','false')):open();});
      wrap.addEventListener('mouseenter',open); wrap.addEventListener('mouseleave',close);
      document.addEventListener('keydown',function(e){if(e.key==='Escape'){mega.classList.remove('is-open');btn.setAttribute('aria-expanded','false');}});
      document.addEventListener('click',function(e){if(!wrap.contains(e.target)){mega.classList.remove('is-open');btn.setAttribute('aria-expanded','false');}});
    });
    // Drawer
    document.querySelectorAll('[data-dlf-drawer-open]').forEach(function(b){ if(b.dataset.dlfBound) return; b.dataset.dlfBound='1'; b.addEventListener('click',function(){document.body.classList.add('dlf-drawer-open');}); });
    document.querySelectorAll('[data-dlf-drawer-close]').forEach(function(b){ if(b.dataset.dlfBound) return; b.dataset.dlfBound='1'; b.addEventListener('click',function(){document.body.classList.remove('dlf-drawer-open');}); });
    // Announcement rotation (mobile)
    document.querySelectorAll('[data-dlf-announce]').forEach(function(el){
      if(el.dataset.dlfBound) return; el.dataset.dlfBound='1';
      var msgs=el.querySelectorAll('.dlf-announce__msg'); if(msgs.length<2) {if(msgs[0])msgs[0].classList.add('is-active');return;}
      var i=0; msgs[0].classList.add('is-active');
      setInterval(function(){msgs[i].classList.remove('is-active');i=(i+1)%msgs.length;msgs[i].classList.add('is-active');},4000);
    });
    // Carousel arrows
    document.querySelectorAll('[data-dlf-carousel]').forEach(function(sec){
      if(sec.dataset.dlfBound) return; sec.dataset.dlfBound='1';
      var track=sec.querySelector('.dlf-products__track'); if(!track) return;
      function step(){var c=track.querySelector('.dlf-card');return c?c.offsetWidth+22:300;}
      var p=sec.querySelector('[data-dir=prev]'),n=sec.querySelector('[data-dir=next]');
      p&&p.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
      n&&n.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    });
    // Favourites
    var favs=[]; try{favs=JSON.parse(localStorage.getItem('dlf-favs')||'[]');}catch(e){}
    document.querySelectorAll('.dlf-card__fav').forEach(function(b){
      if(b.dataset.dlfBound) return; b.dataset.dlfBound='1';
      var id=b.dataset.id; if(favs.indexOf(id)>-1){b.classList.add('is-on');b.textContent='\u2665';}
      b.addEventListener('click',function(){var k=favs.indexOf(id);if(k>-1){favs.splice(k,1);b.classList.remove('is-on');b.textContent='\u2661';}else{favs.push(id);b.classList.add('is-on');b.textContent='\u2665';}try{localStorage.setItem('dlf-favs',JSON.stringify(favs));}catch(e){}});
    });
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
  document.addEventListener('shopify:section:load',init);
})();
